<template>
  <RouterView />
  <ToastNotifications />
  <LiveSessionManager />
</template>

<script setup>
import { RouterView } from 'vue-router';
import ToastNotifications from '@/components/ToastNotifications.vue';
import LiveSessionManager from '@/components/LiveSessionManager.vue';
</script>
